import { FC } from "react"

export const ProviderMarker: FC<{ color: string }> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 40 40"
  >
    {/* Diamond shape rotated 45deg */}
    <rect
      x="6"
      y="6"
      width="28"
      height="28"
      rx="4"
      transform="rotate(45 20 20)"
      fill={color}
      stroke="#fff"
      strokeWidth="2"
    />
    {/* Storefront icon (simplified) */}
    <svg x="10" y="10" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 4H4v2l1 3a3 3 0 005 0 3 3 0 004 0 3 3 0 005 0l1-3V4zM5 12v7a1 1 0 001 1h5v-6h2v6h5a1 1 0 001-1v-7"
        fill="#fff"
        stroke="#fff"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  </svg>
)
